import "./UsaHiringDocuments.scss"
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectAllData, setUsaHiringDocuments } from '../../RecruitmentDataSlice';
import DocumentFormatDownload from './DocumentFormatDownload';
import { docHandler, documentListData, stateWiseTaxForms } from "./HiringDocConfig";
import UploadAndPreview from '../../../../components/upload-preview/UploadAndPreview'
import { useGetStateTaxFormQuery } from "../../../../services/attendance-portal/recruitment/stateTaxForm";


const acceptedFileTypes = ["application/pdf",'image/png','image/jpg','image/jpeg']
function UsaHiringDocuments({ stateTaxForm }) {
    const userState = useSelector(selectAllData);
    const dispatch = useDispatch();
    let defaultMaxSize = 2 * 1000 * 1000
    return (
        <div className='UsaHiringDocuments px-2'>
            <span className='Form font-bold  text-2xl '>Upload Documents</span>
            <div className='text-sm InfoPara my-2'>
                Please download and complete the form that appears in the preview, and then upload it.
            </div>
            {documentListData.map((doc, index) => {
                // if (doc.documentType === 'state_tax_form') {
                //     if (stateTaxForm?.taxFormURL) {
                //         doc.docName = stateTaxForm?.formName
                //         doc.formURL = stateTaxForm?.taxFormURL
                //     }
                //     else {
                //         return null
                //     }
                // }

                let docData = {
                    link: userState.uploadedDocuments[index].base64,
                    type: userState.uploadedDocuments[index].type,
                    name: userState.uploadedDocuments[index].documentName,
                }
                return (
                    <div className="my-3" key={index}>
                        <div className="text-sm font-semibold line-height-4">
                            {doc.title}
                        </div>
                        <div className="grid  align-items-center">
                            <div className="col-5 ">
                                <UploadAndPreview
                                    acceptType={doc.fileType ?? acceptedFileTypes}
                                    maxFileSize={doc.maxFileSize ?? defaultMaxSize}
                                    docData={{ ...docData }}
                                    withOutMargin={true}
                                    className="UsTheme"
                                    VerticalAlignment={false}
                                    onReset={() => docHandler(index, dispatch, setUsaHiringDocuments, null, null, null, userState)}
                                    setDocData={(inputDocData) => {
                                        docHandler(index, dispatch, setUsaHiringDocuments, inputDocData, doc.documentType, doc.docName)
                                    }}
                                />
                            </div>
                            <div className="col-5">Please Upload only .pdf, .png, .jpeg or .jpg file only </div>
                            {/* <div className="col-6 ">
                                <div className="">
                                    {(doc.download ?? false) && <DocumentFormatDownload fileName={doc.docName} fileURL={doc.formURL} />}
                                </div>
                            </div> */}
                        </div>
                    </div>
                )
            }
            )}
        </div>
    )
}

export default UsaHiringDocuments
